import React from "react";
import CompanyMemberForm from "../../components/company/CompanyMemberForm";
import PremiumFormPanel from "../../components/PremiumFormPanel";
import usePremiumResource from "../../hooks/usePremiumResource";
import { premiumPaths } from "../../navigation";

/** Przygotowuje nadanie dostępu i wyklucza użytkowników już przypisanych do firmy. */
export default function AddCompanyMemberPage({ company, token }) {
  const url = `/organizations/${company.id}/members`;
  const resource = usePremiumResource(token, url);
  const listPath = premiumPaths.members(company.id);
  return (
    <PremiumFormPanel
      title="Dodaj użytkownika do firmy"
      resource={resource}
      backTo={listPath}
      backLabel="Użytkownicy firmy"
    >
      <CompanyMemberForm
        members={resource.data?.members || []}
        token={token}
        url={url}
        listPath={listPath}
      />
    </PremiumFormPanel>
  );
}
